<div class="copo-datacenter-filter">
	<button type="button" class="reset-button clear-filter-text" *ngIf="searchTextControl.value" matSuffix mat-button (click)="resetFilter();" tabindex="-1">
		<span translate>datacenter.filter.clear</span>
	</button>
	<div class="filter-number-label">{{this.header}}</div>
	<div class="filter-container">
		<mat-form-field appearance="outline" class="copo-no-error-message">
			<!-- About ag-custom-component-popup: https://www.ag-grid.com/javascript-data-grid/component-filter/#custom-filters-containing-a-popup-element-->
			<mat-select [placeholder]="this.header + '...'" [formControl]="searchTextControl"
			(selectionChange)="selectionChanged()" [attr.aria-label]="this.header" panelClass="ag-custom-component-popup">
				<mat-option *ngFor="let filterItem of filteredItems" [value]="filterItem.code">
					{{ filterItem.translation }}
				</mat-option>
			</mat-select>
			<copo-loading-spinner matSuffix class="loading-spinner-container-input" *ngIf="isLoading"></copo-loading-spinner>
		</mat-form-field>
	</div>
</div>